export const DEFAULT_PIK_REGIONS = [1, 4593];
